import { render, staticRenderFns } from "./SpinnerWithValue.vue?vue&type=template&id=752ee124"
import script from "./SpinnerWithValue.vue?vue&type=script&lang=js"
export * from "./SpinnerWithValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports